import React, { useState } from 'react';
import classNames from 'classnames';

const Pool = ({ title, isSearching, children }) => {
  const [show, setShow] = useState(true);

  const toggleShow = () => {
    setShow(current => !current);
  };

  const icon = show ? 'down' : 'right';

  return (
    <div className={classNames('pool', { 'is-searching': isSearching })}>
      <div className="pool-title mb-1" onClick={toggleShow}>
        <i className={`fa-regular fa-chevron-${icon}`} /> {title}
      </div>
      {show && children}
    </div>
  );
};

export default Pool;
